import { request, errHandler } from "./heimdall";
import store from "../store";

export function getMaintenances() {
  return request
    .get(`/maintenances`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getMaintenance(id) {
  return request
    .get(`/maintenances/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getUserInMaintenance(id) {
  return request
    .get(`/maintenances/user/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function createMaintenance(data) {
  return request
    .post("/maintenances/create", data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateMaintenance(id, data) {
  return request
    .put(`/maintenances/update/${id}`, data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function deleteMaintenance(id) {
  return request
    .delete(`/maintenances/delete/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getUsers() {
  return request
    .get(`/users`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getTypes() {
  return request
    .get(`/types`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function addInvoiceTMA(number, amount, tma_id) {
  return request
    .post(
      `/invoices/create/`, {
        number: number,
        amount: amount,
        tma_id: tma_id
      },
      {
        headers: { Authorization: store.getters.getToken }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateInvoiceTMA(id, number, amount, tma_id) {
  return request
    .put(
      `/invoices/update/${id}`,
      {
        id: id,
        number: number,
        amount: amount,
        tma_id: tma_id
      },
      {
        headers: { Authorization: store.getters.getToken }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

export function removeInvoiceTMA(id) {
  return request
    .delete(`/invoices/delete/${id}`, {
      headers: { Authorization: store.getters.getToken }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}